/* ==========================================================================
   Glacier Supply — theme.js
   Quick view, cart drawer, product forms, gallery, filters, misc UI.
   ========================================================================== */
(function () {
  'use strict';

  var GS = window.GS || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- Utilities ---------- */
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var lockCount = 0;
  function lockScroll() { lockCount++; document.body.classList.add('is-locked'); }
  function unlockScroll() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  function trapTab(e, container) {
    if (e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, container).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* A tiny open/close controller for overlays that fade/slide in */
  function Overlay(el, panelSel) {
    var lastFocus = null;
    var panel = $(panelSel, el);
    var timer = null;
    return {
      el: el,
      isOpen: function () { return !el.hidden && el.classList.contains('is-open'); },
      open: function () {
        if (!el) return;
        clearTimeout(timer);
        lastFocus = document.activeElement;
        el.hidden = false;
        lockScroll();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.add('is-open');
            if (panel) panel.focus({ preventScroll: true });
          });
        });
      },
      close: function () {
        if (!el || el.hidden) return;
        el.classList.remove('is-open');
        unlockScroll();
        timer = setTimeout(function () { el.hidden = true; }, 320);
        if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
      },
      trap: function (e) { trapTab(e, panel || el); }
    };
  }

  var money = (function () {
    var fmt;
    try { fmt = new Intl.NumberFormat(GS.locale || undefined, { style: 'currency', currency: GS.currency || 'USD' }); } catch (e) { fmt = null; }
    return function (cents) { return fmt ? fmt.format(cents / 100) : (cents / 100).toFixed(2); };
  })();

  /* ---------- Announcement bar ---------- */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var msgs = $$('.announcement__msg', bar);
      if (msgs.length < 2) return;
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4500);
    });
  }

  /* ---------- Cart ---------- */
  var drawer = null;
  function setCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', !(n > 0));
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
      setTimeout(function () { el.classList.remove('bump'); }, 300);
    });
    $$('[data-drawer-count]').forEach(function (el) { el.textContent = n; });
  }

  function renderDrawer(html) {
    if (!html) return refreshDrawer();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('[data-cart-drawer-inner]', doc);
    var current = $('[data-cart-drawer-inner]');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      var c = $('[data-drawer-count]', current);
      if (c) setCartCount(parseInt(c.textContent, 10) || 0);
    }
  }

  function refreshDrawer() {
    return fetch(GS.routes.cart + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data['cart-drawer']) renderDrawer(data['cart-drawer']); });
  }

  function openDrawer() { if (drawer) drawer.open(); }

  function addToCart(variantId, quantity) {
    var body = { id: variantId, quantity: quantity, sections: 'cart-drawer' };
    return fetch(GS.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error(data.description || data.message || GS.strings.error); }
        return data;
      });
    });
  }

  function addItems(list) {
    return fetch(GS.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: list, sections: 'cart-drawer' })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { throw new Error(data.description || data.message || GS.strings.error); }
        return data;
      });
    });
  }

  function changeLine(line, quantity) {
    var panel = $('.drawer__panel');
    if (panel) panel.classList.add('is-busy');
    return fetch(GS.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections['cart-drawer']) renderDrawer(cart.sections['cart-drawer']);
        setCartCount(cart.item_count);
      })
      .catch(function () { window.location.href = GS.routes.cart; })
      .then(function () { if (panel) panel.classList.remove('is-busy'); });
  }

  /* ---------- Quick view ---------- */
  var modal = null;
  function openQuickView(card) {
    var tpl = $('template[data-qv-template]', card);
    var content = $('[data-qv-content]');
    if (!tpl || !content || !modal) return false;
    content.innerHTML = '';
    content.appendChild(tpl.content.cloneNode(true));
    initProductForms(content);
    initGalleries(content);
    modal.open();
    var panel = $('.modal__panel', modal.el);
    if (panel) panel.scrollTop = 0;
    return true;
  }

  /* ---------- Gallery ---------- */
  function galleryActivate(g, id) {
    $$('.gallery__item', g).forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-media-id') === String(id)); });
    $$('.gallery__thumb', g).forEach(function (t) {
      var on = t.getAttribute('data-thumb') === String(id);
      t.classList.toggle('is-active', on);
      if (on && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    });
    // pause any playing video that was hidden
    $$('video', g).forEach(function (v) { if (!v.closest('.is-active')) v.pause(); });
  }
  function galleryStep(g, dir) {
    var items = $$('.gallery__item', g);
    var idx = items.findIndex(function (i) { return i.classList.contains('is-active'); });
    var next = items[(idx + dir + items.length) % items.length];
    if (next) galleryActivate(g, next.getAttribute('data-media-id'));
  }
  function initGalleries(root) {
    $$('[data-gallery]', root).forEach(function (g) {
      if (g.dataset.ready) return; g.dataset.ready = '1';
      var x0 = null;
      var main = $('.gallery__main', g);
      if (!main) return;
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 45) galleryStep(g, dx < 0 ? 1 : -1);
      });
    });
  }

  /* ---------- Bulk deals (pack builder) ---------- */
  if (window.customElements && !customElements.get('gs-pack-builder')) {
    customElements.define('gs-pack-builder', class extends HTMLElement {
      connectedCallback() { this.ready(); }
      ready() {
        if (this.started) return;
        this.started = true;
        try { this.config = JSON.parse(this.querySelector('[data-pack-config]').textContent); } catch (e) { return; }
        var c = this.config;
        this.products = [];
        var seen = {};
        [c.current].concat(c.products || []).forEach(function (p) { if (p && !seen[p.id]) { seen[p.id] = 1; this.products.push(p); } }, this);
        this.tiers = c.tiers.map(function (t) { return { qty: t.qty, title: t.title, percent: c.discounts ? t.percent : 0 }; });
        this.tier = 0;
        this.cur = (c.current.variants || [])[0];
        var sel = parseInt(new URLSearchParams(location.search).get('variant'), 10);
        var hit = (c.current.variants || []).filter(function (v) { return v.id === sel; })[0];
        if (hit) this.cur = hit;
        this.slots = [];
        for (var i = 0; i < 10; i++) this.slots.push({ auto: true });
        this.fmt = new Intl.NumberFormat(c.locale || undefined, { style: 'currency', currency: c.currency || 'USD' });
        this.dialog = this.querySelector('dialog');
        var self = this;
        this.querySelector('[data-close]').addEventListener('click', function () { self.dialog.close(); });
        this.dialog.addEventListener('click', function (e) {
          if (e.target !== self.dialog) return;
          var r = self.dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) self.dialog.close();
        });
        this.dialog.addEventListener('close', function () { document.body.style.overflow = self.prevOverflow || ''; });
        this.addEventListener('click', function (e) {
          var tier = e.target.closest('[data-tier]'), change = e.target.closest('[data-change]'), choose = e.target.closest('[data-choose]');
          if (tier) { self.tier = Number(tier.getAttribute('data-tier')); self.render(); var b = self.querySelector('[data-tier="' + self.tier + '"]'); if (b) b.focus(); }
          if (change) { self.edit = Number(change.getAttribute('data-change')); self.catalog(); self.prevOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; self.dialog.showModal(); }
          if (choose) {
            var p = self.products.filter(function (x) { return String(x.id) === choose.getAttribute('data-choose'); })[0];
            if (p) { var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0]; self.slots[self.edit] = { product: p, variant: v }; self.render(); self.dialog.close(); }
          }
        });
        this.addEventListener('change', function (e) {
          if (!e.target.matches('[data-slot-variant]')) return;
          var i = Number(e.target.getAttribute('data-slot-variant')), slot = self.slots[i];
          var v = slot.product.variants.filter(function (x) { return String(x.id) === e.target.value; })[0];
          if (v) { slot.variant = v; self.render(); }
        });
        this.hidden = false;
        this.render();
      }
      setVariant(id) {
        this.ready();
        var v = ((this.config && this.config.current.variants) || []).filter(function (x) { return String(x.id) === String(id); })[0];
        if (v) { this.cur = v; this.render(); }
      }
      resolve(s) { return s.auto ? { product: this.config.current, variant: this.cur } : s; }
      selected(t) { t = t || this.tiers[this.tier]; return this.slots.slice(0, t.qty).map(this.resolve, this); }
      esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
      money(n) { return this.fmt.format(n / 100); }
      pic(p, v) {
        var fi = p.featured_image && typeof p.featured_image === 'object' ? p.featured_image.src : p.featured_image;
        var src = (v && v.featured_image && v.featured_image.src) || fi || (p.images && p.images[0]);
        return src ? '<img src="' + this.esc(src) + '" alt="" loading="lazy" width="64" height="64">' : '<span></span>';
      }
      totals(t) {
        var items = this.selected(t), sub = 0, was = 0, total = 0;
        items.forEach(function (s) {
          var pr = s.variant.price;
          sub += pr; was += Math.max(s.variant.compare_at_price || 0, pr); total += Math.round(pr * (100 - t.percent) / 100);
        });
        return { sub: sub, was: was, total: total };
      }
      render() {
        var self = this, badges = ['', 'Most popular', 'Best value', 'Mega saver'];
        this.querySelector('.pack__tiers').innerHTML = this.tiers.map(function (t, i) {
          var pr = self.totals(t), active = i === self.tier, strike = t.percent ? pr.sub : pr.was;
          var slots = '';
          if (active) {
            slots = self.selected(t).map(function (s, j) {
              var auto = self.slots[j].auto;
              var pick = !auto && s.product.variants.length > 1 && s.product.variants[0].title !== 'Default Title'
                ? '<select class="select pack__vsel" data-slot-variant="' + j + '" aria-label="Choose option for item ' + (j + 1) + '">' + s.product.variants.map(function (v) {
                    return '<option value="' + v.id + '"' + (v.id === s.variant.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + self.esc(v.title) + ' — ' + self.money(v.price) + (v.available ? '' : ' (sold out)') + '</option>';
                  }).join('') + '</select>'
                : (s.variant.title && s.variant.title !== 'Default Title' ? '<span class="pack__vtitle">' + self.esc(s.variant.title) + '</span>' : '');
              return '<div class="pack__slot"><span class="pack__img">' + self.pic(s.product, s.variant) + '</span><div class="pack__slot-info"><div class="pack__slot-title">' + (t.qty > 1 ? (j + 1) + '. ' : '') + self.esc(s.product.title) + '</div>' + pick + '</div>' + (t.qty > 1 ? '<button type="button" class="pack__change" data-change="' + j + '" aria-label="Change item ' + (j + 1) + '">Change</button>' : '') + '</div>';
            }).join('');
          }
          return '<div class="pack__tier' + (active ? ' is-selected' : '') + '">' + (i ? '<span class="pack__badge">' + badges[i] + '</span>' : '') +
            '<button type="button" class="pack__tier-btn" role="radio" aria-checked="' + active + '" tabindex="' + (active ? 0 : -1) + '" data-tier="' + i + '"><span class="pack__dot" aria-hidden="true"></span>' +
            '<span class="pack__tier-text"><b>' + self.esc(t.title) + '</b><small>' + (t.percent ? 'Save ' + t.percent + '%' : (i ? 'Choose your models' : 'Standard price')) + '</small></span>' +
            '<span class="pack__total">' + self.money(pr.total) + (strike > pr.total ? '<s>' + self.money(strike) + '</s>' : '') + '</span></button>' +
            '<div class="pack__slots"' + (active ? '' : ' hidden') + '>' + slots + '</div></div>';
        }).join('');
        var t = this.tiers[this.tier], pr = this.totals(t);
        this.querySelector('.pack__summary').textContent = t.percent
          ? 'Estimated pack total: ' + this.money(pr.total) + ' · Save ' + this.money(pr.sub - pr.total) + '. Automatic discounts are confirmed at checkout.'
          : t.qty + (t.qty === 1 ? ' item selected' : ' items selected') + ' · ' + this.money(pr.total);
      }
      catalog() {
        var self = this, t = this.tiers[this.tier];
        this.querySelector('.pack__catalog').innerHTML = this.products.length ? this.products.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var price = Math.round(v.price * (100 - t.percent) / 100), was = Math.max(v.compare_at_price || 0, v.price);
          return '<div class="pack__row"><span class="pack__img pack__img--lg">' + self.pic(p, v) + '</span><div class="pack__row-info"><p class="pack__row-title">' + self.esc(p.title) + '</p><div class="pack__row-price">' + self.money(price) + (was > price ? ' <s>' + self.money(was) + '</s>' : '') + '</div></div><button type="button" class="btn btn--dark btn--sm" data-choose="' + p.id + '"' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Choose' : 'Sold out') + '</button></div>';
        }).join('') : '<p class="pack__empty">No products available.</p>';
      }
      items() {
        this.ready();
        var map = {}, out = [];
        this.selected().forEach(function (s) {
          var id = String(s.variant.id);
          if (!map[id]) { map[id] = { id: s.variant.id, quantity: 0 }; out.push(map[id]); }
          map[id].quantity++;
        });
        return out;
      }
    });
  }

  function setupPack(box) {
    var el = $('gs-pack-builder', box);
    if (!el) return null;
    return {
      setVariant: function (id) { if (el.setVariant) el.setVariant(id); },
      items: function () { return el.items(); }
    };
  }

  /* ---------- Product form (page + quick view) ---------- */
  function initProductForms(root) {
    $$('[data-product-form]', root).forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var form = $('form', box);
      var dataEl = $('[data-variants]', box);
      if (!form || !dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
      var idInput = $('[data-variant-id]', form);
      var sets = $$('[data-option-index]', box);
      var addBtn = $('[data-add-to-cart]', box);
      var addLabel = $('[data-add-label]', box);
      var buyBtn = $('[data-buy-now]', box);
      var status = $('[data-status]', box);
      var priceBox = $('.pform__price', box);
      var errorEl = $('[data-error]', box);
      var qtyInput = $('.qty__input', box);
      var context = box.getAttribute('data-context');
      var scope = box.closest('.product, .qv');
      var gallery = scope ? $('[data-gallery]', scope) : null;
      var addText = addLabel ? addLabel.textContent.trim() : GS.strings.add;
      if (addText === GS.strings.soldOut || !addText) addText = GS.strings.add;
      var sticky = $('[data-sticky-add]');
      var busy = false;
      var bulkApi = null;
      var delivery = $('[data-delivery]', box);
      var deliveryDate = $('[data-delivery-date]', box);
      if (deliveryDate) {
        var eta = new Date(); eta.setDate(eta.getDate() + (parseInt(GS.deliveryDays, 10) || 4));
        try { deliveryDate.textContent = eta.toLocaleDateString(GS.locale || undefined, { weekday: 'short', month: 'short', day: 'numeric' }); } catch (e) {}
      }

      function selection() { return sets.map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
      function find(sel) {
        return variants.find(function (v) { return v.options.every(function (o, i) { return sel.length ? o === sel[i] : true; }); }) || null;
      }
      function markAvailability() {
        var sel = selection();
        sets.forEach(function (fs, i) {
          $$('.opt__input', fs).forEach(function (input) {
            var test = sel.slice(); test[i] = input.value;
            var matches = variants.filter(function (v) {
              return v.options.every(function (o, j) { return o === test[j]; });
            });
            var ok = matches.some(function (v) { return v.available; });
            var label = input.nextElementSibling;
            if (label) label.classList.toggle('is-unavailable', !ok);
          });
          var chosen = $('input:checked', fs);
          var out = $('[data-opt-selected]', fs);
          if (chosen && out) out.textContent = chosen.value;
        });
      }
      function setButtons(state, text) {
        [addBtn, buyBtn].forEach(function (b) { if (b) b.disabled = state !== 'ok'; });
        if (addLabel) addLabel.textContent = state === 'ok' ? addText : text;
        if (sticky && context === 'page') { sticky.disabled = state !== 'ok'; sticky.textContent = state === 'ok' ? addText : text; }
      }
      function update() {
        var v = find(selection());
        markAvailability();
        errorEl.hidden = true;
        if (!v) {
          setButtons('na', GS.strings.unavailable);
          status.className = 'pform__status is-out'; status.textContent = GS.strings.unavailable;
          if (delivery) delivery.hidden = true;
          return;
        }
        idInput.value = v.id;
        if (bulkApi) bulkApi.setVariant(v.id);
        var sale = v.compare;
        priceBox.innerHTML = '<div class="price' + (sale ? ' price--sale' : '') + '"><span class="price__now" data-price>' + v.price + '</span>' + (sale ? '<s class="price__was" data-compare>' + v.compare + '</s>' : '') + '</div>';
        setButtons(v.available ? 'ok' : 'out', GS.strings.soldOut);
        status.className = 'pform__status ' + (v.available ? 'is-ok' : 'is-out');
        status.textContent = v.available ? 'In stock' : GS.strings.soldOut;
        if (delivery) delivery.hidden = !v.available;
        if (gallery && v.media) galleryActivate(gallery, v.media);
        var sp = $('[data-sticky-price]'); if (sp && context === 'page') sp.textContent = v.price;
        if (context === 'page') {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u); } catch (e) {}
        }
      }

      sets.forEach(function (fs) { fs.addEventListener('change', update); });
      markAvailability();

      function submit(buyNow) {
        if (busy) return;
        var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        busy = true; errorEl.hidden = true;
        var btn = buyNow ? buyBtn : addBtn;
        if (btn) btn.classList.add('is-loading');
        if (addLabel && !buyNow) addLabel.textContent = GS.strings.adding;
        var request = bulkApi ? addItems(bulkApi.items()) : addToCart(parseInt(idInput.value, 10), qty);
        request.then(function (data) {
          if (buyNow) { window.location.href = GS.routes.checkout; return; }
          if (!GS.openCartDrawer || !drawer) { window.location.href = GS.routes.cart; return; }
          renderDrawer(data.sections && data.sections['cart-drawer']);
          return fetch(GS.routes.cartJson).then(function (r) { return r.json(); }).then(function (cart) {
            setCartCount(cart.item_count);
            if (modal && modal.isOpen()) modal.close();
            drawer.open();
          });
        }).catch(function (err) {
          errorEl.textContent = err.message || GS.strings.error;
          errorEl.hidden = false;
        }).then(function () {
          busy = false;
          if (btn) btn.classList.remove('is-loading');
          update();
        });
      }

      form.addEventListener('submit', function (e) { e.preventDefault(); submit(false); });
      if (buyBtn) buyBtn.addEventListener('click', function () { submit(true); });
      if (sticky && context === 'page' && !sticky.dataset.bound) {
        sticky.dataset.bound = '1';
        sticky.addEventListener('click', function () { submit(false); });
        // show the bar once the main add button scrolls out of view
        var bar = $('[data-sticky-atc]');
        if (bar && 'IntersectionObserver' in window && addBtn) {
          bar.hidden = false;
          new IntersectionObserver(function (entries) {
            var e = entries[0];
            bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
          }).observe(addBtn);
        }
      }
      bulkApi = setupPack(box);
      update();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealObs = null;
  function initReveal(root) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!revealObs) {
      revealObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObs.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    }
    $$('.pcard, .cat, .feature, .review, .acc, .section__head', root).forEach(function (el, i) {
      if (el.dataset.rv) return; el.dataset.rv = '1';
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // already visible: don't hide
      el.classList.add('reveal');
      el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
      revealObs.observe(el);
    });
  }

  /* ---------- Related products (recommendations) ---------- */
  function initRelated(root) {
    $$('[data-related]', root).forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      if (el.querySelector('.grid')) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-related]', doc);
        if (fresh && fresh.querySelector('.grid')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          initReveal(el);
        }
      }).catch(function () {});
    });
  }

  /* ---------- Collection filters ---------- */
  var filterTimer = null;
  function initCollection() {
    var form = $('#CollectionForm');
    if (!form || form.dataset.ready) return; form.dataset.ready = '1';
    form.addEventListener('submit', function () {
      $$('[form="CollectionForm"]').forEach(function (el) { if (el.type === 'number' && el.value === '') el.disabled = true; });
    });
  }
  function filtersToggle(force) {
    var panel = $('[data-filters]'); var back = $('.filters-backdrop');
    if (!panel) return;
    var open = typeof force === 'boolean' ? force : !panel.classList.contains('is-open');
    panel.classList.toggle('is-open', open);
    if (back) back.classList.toggle('is-open', open);
    $$('[data-filters-toggle]').forEach(function (b) { if (b.tagName === 'BUTTON') b.setAttribute('aria-expanded', open); });
    if (open) lockScroll(); else if (panel.dataset.wasOpen) unlockScroll();
    panel.dataset.wasOpen = open ? '1' : '';
  }

  /* ---------- Global events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    // Quick view
    var trig = t.closest('[data-qv-trigger]');
    if (trig && GS.quickView && !e.defaultPrevented && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      var card = trig.closest('[data-product-card]');
      if (card && openQuickView(card)) { e.preventDefault(); return; }
    }
    if (t.closest('[data-qv-close]')) { if (modal) modal.close(); return; }

    // Cart drawer
    var openBtn = t.closest('[data-cart-open]');
    if (openBtn && drawer && GS.openCartDrawer && window.location.pathname !== GS.routes.cart && !e.metaKey && !e.ctrlKey) {
      e.preventDefault(); refreshDrawer().then(openDrawer, openDrawer); return;
    }
    if (t.closest('[data-drawer-close]')) { if (drawer) drawer.close(); return; }
    var chg = t.closest('[data-cart-change]');
    if (chg) { e.preventDefault(); changeLine(parseInt(chg.dataset.line, 10), parseInt(chg.dataset.quantity, 10)); return; }

    // Quantity steppers
    var minus = t.closest('[data-qty-minus]'), plus = t.closest('[data-qty-plus]');
    if (minus || plus) {
      var input = $('.qty__input', (minus || plus).closest('.qty'));
      if (input) {
        var min = input.hasAttribute('min') ? parseInt(input.min, 10) : 1;
        var val = (parseInt(input.value, 10) || 0) + (plus ? 1 : -1);
        input.value = Math.max(min, val);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Gallery
    var th = t.closest('[data-thumb]');
    if (th) { galleryActivate(th.closest('[data-gallery]'), th.getAttribute('data-thumb')); return; }
    var pv = t.closest('[data-gallery-prev]'), nx = t.closest('[data-gallery-next]');
    if (pv || nx) { galleryStep((pv || nx).closest('[data-gallery]'), nx ? 1 : -1); return; }

    // Header: menu & search
    var mt = t.closest('[data-menu-toggle]');
    if (mt) {
      var nav = $('[data-mobile-nav]'); var open = nav.hidden;
      nav.hidden = !open; mt.setAttribute('aria-expanded', open);
      $('[data-icon-open]', mt).hidden = open; $('[data-icon-close]', mt).hidden = !open;
      return;
    }
    var st = t.closest('[data-search-toggle]');
    if (st) {
      var panel = $('[data-search-panel]'); var o = panel.hidden;
      panel.hidden = !o; st.setAttribute('aria-expanded', o);
      if (o) { var inp = $('input[type=search]', panel); if (inp) setTimeout(function () { inp.focus(); }, 30); }
      return;
    }

    // Filters
    if (t.closest('[data-filters-toggle]')) { filtersToggle(); return; }

    // Share
    var sh = t.closest('[data-share]');
    if (sh) {
      var data = { title: sh.dataset.title, url: sh.dataset.url };
      if (navigator.share) { navigator.share(data).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { var old = sh.textContent; sh.textContent = 'Link copied!'; setTimeout(function () { sh.textContent = old; }, 1800); }); }
    }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('[data-auto-submit]')) {
      var form = $('#CollectionForm');
      if (!form) return;
      clearTimeout(filterTimer);
      filterTimer = setTimeout(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }, t.type === 'number' ? 600 : 120);
    }
    if (t.matches('[data-cart-qty]')) {
      var cf = t.closest('form');
      var min = Math.max(0, parseInt(t.value, 10) || 0); t.value = min;
      clearTimeout(filterTimer);
      filterTimer = setTimeout(function () { cf.submit(); }, 500);
    }
    if (t.matches('.qty__input') && !t.matches('[data-cart-qty]')) {
      t.value = Math.max(1, parseInt(t.value, 10) || 1);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (modal && modal.isOpen()) { modal.close(); return; }
      if (drawer && drawer.isOpen()) { drawer.close(); return; }
      var fp = $('[data-filters]'); if (fp && fp.classList.contains('is-open')) { filtersToggle(false); return; }
      var sp = $('[data-search-panel]'); if (sp && !sp.hidden) { sp.hidden = true; var tg = $('[data-search-toggle]'); if (tg) { tg.setAttribute('aria-expanded', 'false'); tg.focus(); } }
    }
    if (e.key === 'Tab') {
      if (modal && modal.isOpen()) modal.trap(e);
      else if (drawer && drawer.isOpen()) drawer.trap(e);
    }
  });

  /* ---------- Boot ---------- */
  function init(root) {
    initAnnouncement(root);
    initProductForms(root);
    initGalleries(root);
    initRelated(root);
    initReveal(root);
    initCollection();
  }

  function boot() {
    var drawerEl = $('[data-cart-drawer]');
    var modalEl = $('[data-qv-modal]');
    if (drawerEl) drawer = Overlay(drawerEl, '.drawer__panel');
    if (modalEl) modal = Overlay(modalEl, '.modal__panel');
    init(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target || document;
    init(el);
    // re-bind drawer if the cart drawer section was re-rendered
    var drawerEl = $('[data-cart-drawer]');
    if (drawerEl && (!drawer || drawer.el !== drawerEl)) drawer = Overlay(drawerEl, '.drawer__panel');
  });
  document.addEventListener('shopify:section:unload', function () { /* nothing persistent to clean up */ });
})();
